export default {
    data() {
        return {
            username: (localStorage.getItem("username") == null || localStorage.getItem("username") == undefined || localStorage.getItem("username") == "undefined") ? "" : localStorage.getItem("username"),
            password: "",
            remember: localStorage.getItem("remember") == 1 ? true : false
        }
    },
    mounted: function() {

    },
    methods: {
        /**
         * 登录
         */
        login: function() {
            if (this.username.length == 0) {
                this.$message.closeAll();
                this.$message.error("请输入用户名");
                return;
            }
            if (this.password.length == 0) {
                this.$message.closeAll();
                this.$message.error("请输入密码");
                return;
            }
            this.$post({
                url: 'user/login',
                params: {
                    username: this.username,
                    password: this.$md5(this.password)
                }
            }, true).then(response => {
                localStorage.setItem("token", response);
                localStorage.setItem("remember", this.remember ? 1 : 0);
                if (this.remember) {
                    localStorage.setItem("username", this.username);
                } else {
                    localStorage.removeItem("username");
                }
                this.getUserInfo(response);
            });
        },

        /**
         * 获取用户信息
         */
        getUserInfo: function(token) {
            this.$post({
                url: 'user/userInfo',
                params: {
                    token: token
                }
            }, true).then(response => {
                this.$message.closeAll();
                this.$message.success("登录成功");
                sessionStorage.setItem("isLogin", true);
                sessionStorage.setItem("userInfo", JSON.stringify(response));
                if (response.userType == 1) { //管理员
                    this.$router.replace("/console");
                } else {
                    this.$message.closeAll();
                    this.$message.error("无权限登录");
                }
            });
        }
    }
}